import withStyles from '@mui/styles/withStyles'
import Switch from '@mui/material/Switch'

const SwitchOverided = withStyles((theme) => ({
    switchBase: {
        '&$checked': {
            color: theme.palette.primary.main,
        },
        '&$checked + $track': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    thumb: {
        boxShadow: '0px 1px 12px rgba(0,0,0,0.2)',
    },
    track: {},
    checked: {},
}))(Switch)

export default SwitchOverided
